export default __webpack_public_path__ + "static/media/Murali Srinivasan.60a430f0.jpg";